var _path, _path2, _path3, _path4, _circle, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSaveWithMark = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.08936 2H22.8766C23.4782 2 23.966 2.48772 23.966 3.08936V24.8766C23.966 25.4782 23.4782 25.966 22.8766 25.966H1.08936C0.487724 25.966 0 25.4782 0 24.8766V3.08936C0 2.48772 0.487724 2 1.08936 2ZM2.17872 23.7872H21.7872V4.17872H2.17872V23.7872Z",
    fill: "#4A4A4A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5362 20.5191C7.13784 20.5191 7.62556 20.0314 7.62556 19.4297V11.8042C7.62556 11.2026 7.13784 10.7148 6.5362 10.7148C5.93456 10.7148 5.44684 11.2026 5.44684 11.8042V19.4297C5.44684 20.0314 5.93456 20.5191 6.5362 20.5191Z",
    fill: "#4A4A4A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.983 20.5196C12.5846 20.5196 13.0723 20.0319 13.0723 19.4302V8.53663C13.0723 7.93499 12.5846 7.44727 11.983 7.44727C11.3813 7.44727 10.8936 7.93499 10.8936 8.53663V19.4302C10.8936 20.0319 11.3813 20.5196 11.983 20.5196Z",
    fill: "#4A4A4A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4298 20.5191C18.0314 20.5191 18.5191 20.0314 18.5191 19.4297V11.8042C18.5191 11.2026 18.0314 10.7148 17.4298 10.7148C16.8281 10.7148 16.3404 11.2026 16.3404 11.8042V19.4297C16.3404 20.0314 16.8281 20.5191 17.4298 20.5191Z",
    fill: "#4A4A4A"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 8,
    r: 8,
    fill: "#4A4A4A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1316 5.24104L17.4453 8.92734L15.4763 6.95839C15.2607 6.73518 14.9415 6.64565 14.6413 6.72423C14.341 6.80282 14.1066 7.03727 14.028 7.33749C13.9494 7.63771 14.0389 7.95697 14.2622 8.17256L16.8382 10.7486C17.1735 11.0838 17.717 11.0838 18.0524 10.7486L22.3457 6.45521C22.6712 6.11828 22.6665 5.58272 22.3353 5.2515C22.0041 4.92028 21.4685 4.91563 21.1316 5.24104Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSaveWithMark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/saveWithMark.b4c070dcb96486ea67570265775105d5.svg";